<template>
  <div>
    <div class="home d-flex">
      <video playsinline autoplay muted loop poster="../assets/video/nadvorie_cover.jpg" id="bgvid">
        <source src="../assets/video/nadvorie.mp4" type="video/mp4">
      </video>
      <div class="intro-text d-flex align-items-end px-md-5">
        <div>
          <h1>Bory Nádvorie</h1>
          <p v-html="$t('Nová etapa v&nbsp;dynamickej časti štvrti Bory, ktorá ponúka výbornú <br>občiansku vybavenosť v&nbsp;pešej dostupnosti. Obchody, služby, kino či fitness centrum len pár minút od polouzavretého vnútrobloku.')"></p>
          <b-button @click="scrollTo('district')" class="d-block d-md-inline-block" squared variant="primary">{{ $t('Zistiť viac') }}</b-button>
          <b-button href="https://mollyinvr.com/projects/penta/nadvorie/?project=EXT" target="_blank" class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0 btn btn-white">{{ $t('Virtuálna prehliadka exteriérov') }}</b-button>
          <b-button href="https://mollyinvr.com/projects/penta/nadvorie/" target="_blank" class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0 btn btn-white">{{ $t('Virtuálna prehliadka interiérov') }}</b-button>
        </div>
      </div>
      <div class="sticker">
        <a v-if="locale == 'sk'" href="../nabytok"><img src="../assets/images/sticker.png"></a>
        <a v-if="locale == 'en'" href="../nabytok"><img src="../assets/images/badge_EN.png"></a>
      </div>
    </div>

    <section class="district p-md-3 pt-3 pt-md-5" id="district">
      <div class="d-flex flex-wrap align-items-start top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">{{ $t('Mesto tak, ako ho poznáte') }}</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">{{ $t('Bory kombinujú aktívne rodinné bývanie s bohatým verejným priestorom, kompletnou vybavenosťou, množstvom obchodov a pohodlnou dopravou do centra.') }}</p>
        </div>
      </div>
      <div id="mapbox" class="position-relative">
        <BuildingMap
          stage="bory5"
          map-key="b5"
          background-image="/map/b5.jpg"
          marker-color="#C3542B"
          :marker-scale="1.2"
          svg-top-offset="-6px"
        />
        <div id="vr-badge">
          <a href="https://mollyinvr.com/projects/penta/nadvorie/" target="_blank">
            <div class="d-flex flex-column align-items-center justify-content-center p-4 text-center box">
              <img src="../assets/icons/360.svg">
              <p>{{ $t('Prejdite sa Virtuálnou realitou') }}</p>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section id="tabulka">
      <FlatsTable :stages="['bory5']" :showStageAndDate="false" :show-vr="true" :showEntrance="true"></FlatsTable>
    </section>

    <ScheduleTimeline :phases="schedulePhases" />

    <!-- <section class="district p-md-3 pt-3 pt-md-5">
      <div class="d-flex flex-wrap align-items-center top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">Prejdite sa projektom <br>vo virtuálnej realite</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">Pomocou virtuálnej reality sa môžete <br>prejsť areálom ale aj jednotlivými bytmi <br>projektu Bory Nádvorie už dnes.</p>
        </div>
      </div>
      <div id="mapbox2" class="position-relative">
        <div id="bory-vr">
          <div id="woowstudio" data-zoom="disablewheel"></div>
        </div>
      </div>
    </section> -->

    <section class="section-3 p-3" id="section-1">
      <div class="">
        <div class="row px-3">
          <div class="col-md-7 bg-img"></div>
          <div class="col-md-5 p-0 px-md-5 py-3 pb">
            <h2>{{ $t('Vyskúšajte virtuálnu realitu interiéru') }}</h2>
            <p class="mb-5">{{ $t('Prejdite sa interiérom vami vybraného bytu pomocou virtuálnej reality a presvedčte sa o jeho skvelej dispozícii už dnes.') }}</p>
            <b-button href="https://mollyinvr.com/projects/penta/nadvorie/" class="d-block d-md-inline-block mb-4" target="_blank" squared variant="primary">{{ $t('Virtuálna prehliadka interiéru') }}</b-button>
            <div class="d-none d-md-block">
              <br>
              <br>
              <br>
              <br>
              <br>
              <br>
            </div>
          </div>
        </div>
      </div>
    </section>
    

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-4 py-4">
          <h2 class="mb-4">{{ $t('Domov, ktorý oslní') }}</h2>
          <p class="mb-3" v-html="$t('Doma je tam, kde sa cítite sami sebou. Aj preto si môžete vybrať z&nbsp;viacerých úrovní štandardov, ktoré pre vás precízne vytvárame tak, aby naplnili očakávania aj náročných klientov. Samozrejmosťou sú kvalitné materiály a&nbsp;rôzne farebné prevedenia.')"></p>
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0">
          <div class="right-img bg-img-2"></div>
        </div>
      </div>
    </section>

    <section class="section-3 p-3">
      <div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3>{{ $t('Atraktívna zeleň') }}</h3>
              <p>{{ $t('Zelené zóny, projektované pre deti aj dospelých, zabezpečia kvalitné trávenie voľného času aj priestor na oddych.') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3>{{ $t('Detské ihriská') }}</h3>
              <p v-html="$t('Premyslene navrhnuté detské ihriská, pre bezstarostné hry detí, situované v&nbsp;bezpečnej časti bez áut.')"></p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3>{{ $t('Hrádza aj škôlka na skok') }}</h3>
              <p v-html="$t('Ranný beh či popoludňajšie korčuľovanie len na skok od vášho bytu. Rovnako aj škôlka, ktorá sa nachádza 5&nbsp;minút pešo.')"></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 bg"></div>
        <div class="col-md-6 signature-section">
          <h2 class="mb-4" v-html="$t('Buďte v&nbsp;centre <br>diania')"></h2>
          <p class="mb-5" v-html="$t('Etapa Bory Nádvorie sa vyznačuje <br>premysleným architektonickým riešením <br>dvoch budov, ktoré spoločne vytvárajú <br>príjemný vnútroblok. Ten zaručí dostatočné <br>súkromie s&nbsp;prirodzeným prepojením do celej štvrte.')"></p>
        </div>
      </div>
    </section>

    <ContactForm selectedStage="bory3b" id="contact-form"></ContactForm>
  </div>
</template>

<script>
import FlatsTable from "@/components/flats/FlatsTable";
import BuildingMap from "@/components/maps/BuildingMap";
import ContactForm from "@/components/shared/ContactForm";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";
import store from "@/store";

export default {
  name: "Nadvorie",
  components: {BuildingMap, FlatsTable, ContactForm, ScheduleTimeline},
  data() {
    return {
      schedulePhases: [
        { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '3. kvartál 2025', status: 'fill-min' },
        { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2027' },
        { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2027' },
        { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 2. kvartál 2028' },
        { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
      ]
    }
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      const offset = 80; // Adjust this value to set the offset in pixels
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
  },
  computed: {
    locale() {
      return store.state.lang.$locale
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
$large: 1180px

.sticker
  position: absolute
  bottom: 50px
  right: 50px
  width: 250px
  z-index: 10

  @media (max-width: $large)
    width: 200px
    bottom: auto
    top: 150px
    right: auto
    left: 50px

#mapbox
  padding: 0

#mapbox2
  padding: 0
  z-index: 9999

video
  object-fit: cover
  width: 100vw
  height: 100vh
  position: absolute
  top: 0
  left: 0

#vr-badge
  position: absolute
  width: 140px
  height: 140px
  background: #fff
  border-radius: 50%
  top: 35%
  right: 10%
  z-index: 99
  cursor: pointer

  @media (max-width: $md)
    width: 110px
    height: 110px
    bottom: 20px
    right: 20px

  img
    max-width: 70%
    margin-bottom: 2px

  p
    color: #000
    font-size: 16px

    @media (max-width: $md)
      font-size: 14px

#bory-vr
  width: 100%
  height: 80vh
  background: #ccc
  position: relative
  box-sizing: border-box

#woowstudio
  position: absolute
  width: 100%
  height: 100%
  padding: 0
  margin: 0
  box-sizing: border-box

.about-bottom-2
  .bg
    background: url('../assets/images/bory5/06H_BH3B_static_ext_round_02.jpg') top/cover no-repeat

  .signature-section
    h2
      max-width: 570px
      font-size: 40px
      line-height: 45px
      letter-spacing: -1px
      font-weight: 400
      @media (max-width: $md)
        font-size: 28px
        line-height: 40px
        letter-spacing: -1px
    p
      max-width: 570px

    .btn
      align-self: flex-start
.about-bottom
  padding-bottom: 11px!important
  .right-img
    background: url(../assets/images/bory3/bory3-domov.jpg) center/cover no-repeat
  .bg-img-2
    background: url("../assets/images/bory5/01C.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover


.section-3
  background: var(--grey)
  color: #fff
  text-align: left
  .bg-img
    background: url("../assets/images/nadvorie_konfig.jpg") top/cover no-repeat
    background-position: center
  
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 480px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      max-width: 320px
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory5/05P_BH3B_static_ext_round_01.jpg") center/cover no-repeat
    background-position: left center

    @media (max-width: $md)
      background-position: center
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory5/01E_BH3B_static_ext_round_02.jpg") bottom/cover no-repeat
    background-position: -200px center
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory5/04D_BH3B_static_ext_round_02.jpg") center/cover no-repeat
    background-position: left center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory5/01E_BH3B_static_ext_round_02.jpg") bottom/cover no-repeat
  position: relative

  &:after
    content: ""
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%)
  .intro-text
    position: relative
    z-index: 9
  p
    margin-bottom: 30px
    max-width: 770px

  .btn-white
    background: #fff
    color: #001F33
    border-radius: 0
    border-color: #fff
    position: relative
    // padding-left: 55px

    // &:before
    //   content: ""
    //   width: 27px
    //   height: 16px
    //   background: url("../assets/icons/360.svg") center/contain no-repeat
    //   position: absolute
    //   left: 15px
    //   top: 50%
    //   transform: translateY(-50%)

    &:hover
      background: #CFEDFF
      border-color: #CFEDFF

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
